import React from 'react';
import SolidBlueBtn from '../../components/buttons/SolidBlueBtn';
import styled from 'styled-components';
import { CANT_SEE_SOME_STORES } from '../../text-data';
const MyDiv = styled.div`
  padding: 24px 20px 16px 20px;
`;
export default function CantSeeSomeStoreGuide({ closeModal }) {
  return (
    <MyDiv className='flex flex-col gap-6'>
      <b className='text-lg'>{CANT_SEE_SOME_STORES}</b>
      <ul className='list-disc pl-6'>
        <li className='mb-6'>쿠팡이츠는 글자 수의 제한으로 추가 댓글을 제공하지 않아요.</li>
        <li className='mb-6'>
          매장 하나당 1개의 추가 댓글만 설정할 수 있으며, 이미 추가 댓글이 설정된 경우 기존 추가 댓글에서 제외 후 다시 시도해 주세요.
        </li>
        <li>관심리뷰에는 추가 댓글이 적용되지 않아요.</li>
      </ul>

      <SolidBlueBtn onClick={closeModal}>확인</SolidBlueBtn>
    </MyDiv>
  );
}
